import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Timeline.css';

const events = [
  {
    date: 'MARCH 2006 - December 2009',
    title: 'The Foundation Years', 
    description:
'In 2006, we rented a modest space near the Okhla Bird Sanctuary — not just to build an office, but to shape a vision. It wasn’t about interiors or walls; it was about crafting a future. This was where Aligned Vertical took root, driven by clarity of purpose and determination.With a small, passionate team, we began our journey in the rugged terrains of Ladakh—taking on challenging infrastructure projects that tested our skill and spirit. From roads to hydro systems, we laid the foundation for Aligned Vertical core values: quality, trust, and impact. make shorter',},
  {
    date: 'JANUARY 2010 - NOVEMBER 2012',
    title: 'Expansion of Presance',
    description:
      'Expanded operations across India with regional offices in:Mumbai, Delhi, Chennai, Guwahati, BangaloreStrengthened service capacity in both urban and rural sectors.Built strong relationships in public infrastructure and development.',},
  {
    date: 'FEBRUARY 2012 - DECEMBER 2015',
    title: 'Entry into Telecom & Managed Services',
    description:
      'Long-term consulting, hardware/software sales, and managed services.Supported clients like mobile service providers, government networks, and network operators.Laid the foundation for carrier-grade service support.',},
  {  
    date: 'MARCH 2016 - November 2018',
    title: 'Global Growth & Strategic Partnerships',
    description:
      'Established Global Corporate HQ in Kolkata with an expanding global reach.Formed trusted partnerships with leading international clients:Tata Communications (USA)Adani Power PlantSTC – Saudi Telecom CompanyLarsen & Toubro (L&T)Net Denmark...and many more.Aligned Vertical now operates as a full-service managed service provider, supporting defense, government, and telecom institutions.',
  },
   {  
    date: 'February 2019 - December 2021',
    title: 'Building Technology Leadership',
    description:
      'Introduced 30+ telecom solutions for service providers.Provided complete IT infrastructure services:Servers, Storage, NetworksSpecialized in Solaris, SUN Oracle, HP, Dialogic, and more.Strengthened team in software development, maintenance, and support.',
  },
   {  
    date: 'MARCH 2022 - Present',
    title: 'Innovation, IT Services & Global Presence',
    description:
    'Aligned Vertical continues its global expansion, offering advanced telecom, defense, and infrastructure solutions. The company has diversified into IT services, including custom website and mobile app development for clients across sectors. With a strong focus on managed services, smart network integrations, and digital transformation, Aligned Vertical is shaping the future through innovation, technology, and trusted partnerships.',
  },


];

const Timeline = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="timeline-container">
      <h2 className="timeline-heading">Est. 2004</h2>
      <div className="timeline-line"></div>
      {events.map((event, index) => (
        <div
          className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
          key={index}
          data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
        >
          <div className="timeline-content">
            <span className="timeline-date">{event.date}</span>
            <h3 className="timeline-title">{event.title}</h3>
            <p className="timeline-desc">{event.description}</p>
          </div>
          <div className="timeline-dot-line">
            <span className="timeline-dot"></span>
            <span className="timeline-connector"></span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
